import React from 'react';
import { View, StyleSheet, ScrollView, Platform, RefreshControl } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { useResponsive } from '@/hooks/common/useResponsive';
import { MaintenanceCard } from './MaintenanceCard';
import { TicketTypes } from './MaintenanceEmptyState';
import { MaintenanceList } from './MaintenanceList';
import { useMaintenanceTickets } from '@/hooks/residents/useMaintenanceTickets';

export const MaintenanceSolved: React.FC<{ onCreateTicket?: () => void }> = ({ onCreateTicket }) => {
  const { layoutMode } = useResponsive();
  const isDesktop = layoutMode === 'desktop';
  const { closedTickets, loading, error, refresh } = useMaintenanceTickets();

  if (!isDesktop) {
    // Mobile view
    return (
      <ScrollView
        style={styles.mobileContainer}
        contentContainerStyle={styles.mobileContent}
        refreshControl={<RefreshControl refreshing={!!loading} onRefresh={refresh} tintColor="#007AFF" />}
      >
        {/* Provide CTA similar to iOS footer availability, even on closed tab */}
        {/* Consumers may place this CTA elsewhere; keeping minimal to match behavior */}
        <MaintenanceList
          loading={loading}
          error={error}
          items={closedTickets}
          emptyType={TicketTypes.SOLVED}
          renderItem={(t) => (<MaintenanceCard key={t.maintenanceRequestId} ticket={t} />)}
        />
      </ScrollView>
    );
  }

  // Desktop view
  return (
    <View style={styles.desktopContainer}>
      <MaintenanceList
        loading={loading}
        error={error}
        items={closedTickets}
        emptyType={TicketTypes.SOLVED}
        renderItem={(t) => (<MaintenanceCard key={t.maintenanceRequestId} ticket={t} />)}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  // Mobile styles
  mobileContainer: {
    flex: 1,
    backgroundColor: '#F2F2F7',
  },
  mobileContent: {
    padding: 16,
  },
  ticketsContainer: {
    gap: 12,
  },

  // Desktop styles
  desktopContainer: {
    backgroundColor: RESIDENTS_DESKTOP_COLORS.SECONDARY_BACKGROUND,
    padding: 24,
    width: '100%',
  },
  loadingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 40,
  },
  loadingText: {
    fontSize: 16,
    color: '#6B7280',
    textAlign: 'center',
    marginTop: 16,
    paddingHorizontal: 32,
  },
  desktopLoadingText: {
    fontSize: 16,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
    textAlign: 'center',
    marginTop: 16,
    paddingHorizontal: 32,
  },
  desktopTicketsGrid: {
    width: '100%',
  },
  desktopGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 16,
    ...(Platform.OS === 'web' && ({
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)', // 3 columns like resio-web
      gridGap: 16,
    } as any)),
  },
});
